module.exports = __webpack_public_path__ + "static/img/10.29b45e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/10.jpg
// module id = tNK9
// module chunks = 16